import React from "react";
import Filter from "../components/Category/Filter/Filter";
import Container from "../components/layout/Container";
import MoreItems from "../components/Shared/MoreItems/MoreItems";
import CategoryList from "../components/Shared/Category/CategoryList";
import { products } from "../data/products";
import Ads from "../components/Category/Ads/Ads";

const Category = () => {
  return (
    <Container>
      <CategoryList />
      <MoreItems products={products} title="Featured Ads" />
      <div className="flex items-start justify-between gap-4">
        <Filter />
        <Ads />
      </div>
    </Container>
  );
};

export default Category;
